var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graph-5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 20,
    height: 20,
    viewBox: "0 0 1010 1010",
    enableBackground: "new 0 0 1010 1010",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph-5-graph-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#323B5A",
    points: "1010,928.5039 81.4746,928.5039 81.4746,0 44.7754,0 44.7754,928.5039 0,928.5039 0,965.2451 44.7754,965.2451 44.7754,1010 81.4746,1010 81.4746,965.2451 1010,965.2451  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323B5A",
    d: "M399.812,465.5879c-10.1509,0-18.3701,8.1987-18.3701,18.3496v378.75 c0,10.1514,8.2192,18.3711,18.3701,18.3711h84.126c10.1509,0,18.3701-8.2197,18.3701-18.3711v-378.75 c0-10.1509-8.2192-18.3496-18.3701-18.3496H399.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323B5A",
    d: "M189.375,633.9004c-10.1509,0-18.3496,8.2402-18.3496,18.3711v210.416 c0,10.1514,8.1987,18.3711,18.3496,18.3711h84.187c10.1099,0,18.3501-8.2197,18.3501-18.3711v-210.416 c0-10.1309-8.2402-18.3711-18.3501-18.3711H189.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323B5A",
    d: "M610.209,633.9004c-10.1309,0-18.3506,8.2402-18.3506,18.3711v210.416 c0,10.1514,8.2197,18.3711,18.3506,18.3711h84.166c10.1504,0,18.3701-8.2197,18.3701-18.3711v-210.416 c0-10.1309-8.2197-18.3711-18.3701-18.3711H610.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323B5A",
    d: "M820.625,423.5044c-10.1504,0-18.3711,8.2197-18.3711,18.3706v420.8125 c0,10.1514,8.2207,18.3711,18.3711,18.3711h84.166c10.1309,0,18.3506-8.2197,18.3506-18.3711V441.875 c0-10.1509-8.2197-18.3706-18.3506-18.3706H820.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323B5A",
    d: "M173.2856,598.4336c4.1919,0,8.3838-1.418,11.836-4.3359l281.6377-238.0743l154.7095,155.0801 c3.4316,3.4727,8.4257,4.9727,13.0078,5.3828c4.8906-0.0205,9.5753-1.9511,13.0273-5.4238l256.0342-258.2544 c7.1514-7.1919,7.0693-18.8428-0.1231-25.9731c-7.1923-7.1509-18.8427-7.1304-25.9531,0.1025L634.4141,472.0811L480.8145,318.1318 c-6.7398-6.7807-17.5279-7.2329-24.8433-1.0683L161.4087,566.0498c-7.7676,6.5547-8.7129,18.1436-2.1577,25.8916 C162.8677,596.2354,168.0664,598.4336,173.2856,598.4336z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStats);
export default __webpack_public_path__ + "static/media/icon_stats.11ecd38f69658490f83263944c893075.svg";
export { ForwardRef as ReactComponent };